import styled from 'styled-components';

import { Card, ActionButton } from '@feedback/ui';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  background-color: #eceff1;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
`;

const WarningCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Text = styled.span`
  font-size: 23;
  margin-bottom: 20px;
`;

type Props = {
  domainName: string;
};
const DomainNotFound = ({ domainName }: Props) => {
  return (
    <Wrapper>
      <Container>
        <WarningCard>
          <h2>
            Ops! Time &quot;
            {domainName}
            &quot;
          </h2>
          <Text>Não foi encontrado.</Text>
          <ActionButton href="https://feedback.house">Criar</ActionButton>
        </WarningCard>
      </Container>
    </Wrapper>
  );
};

export default DomainNotFound;
